'use strict';

function forceStringCoercion(obj) {
  var i = 0, chr;
  while (chr = obj.charAt(i)) {
    obj[i++] = chr;
  }
}

module.exports = forceStringCoercion;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/forceStringCoercion.js
// module id = 445
// module chunks = 0